<div class="container">
	<section>
		<div class="header">
			<h3 i18n [ngClass]="!message ? 'title' : ''">{{ title || "Подтвердить действие?" }}</h3>
			<app-icon *ngIf="!message" (click)="appConfirm.emit()">clear</app-icon>
		</div>
		<p *ngIf="message" class="message-block">
			{{message}}
		</p>
	</section>
	
	<nav>
		<button i18n [appSkin]="'action'" (click)="appConfirm.emit(true)">{{ agreeButtonText || "ОК" }}</button>
		<button i18n *ngIf="!withoutDisagree" [appSkin]="'simple-cancel'"
			(click)="appConfirm.emit(false)">
			<ng-container *ngIf="disagreeButtonText">{{ disagreeButtonText }}</ng-container>
			<ng-container *ngIf="!disagreeButtonText">Отмена</ng-container>
		</button>
	</nav>
</div>
